import { useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
// import { withAuthGuard } from "../../hocs/with-auth-guard";
import { SideNav } from "./SideNav";
import { TopNav } from "./TopNav";
import { useLocation } from "react-router-dom";

const SIDE_NAV_WIDTH = 280;

const LayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingTop: 2,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: SIDE_NAV_WIDTH,
    paddingTop: 75,
  },
}));

const LayoutContainer = styled("div")({
  // background: "rgb(177, 165, 143, 0.06)",
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
  height: "100%",
});

export const BasicPageLayout = (props) => {
  const { children } = props;
  const pathname = useLocation().pathname;

  const [openNav, setOpenNav] = useState(false);

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false);
    }
  }, [openNav]);

  useEffect(
    () => {
      handlePathnameChange();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );

  return (
    <>
      <TopNav onNavOpen={() => setOpenNav(true)} key={"1"} />
      <SideNav onClose={() => setOpenNav(false)} open={openNav} key={"2"} />

      <LayoutRoot>
        <LayoutContainer>{children}</LayoutContainer>
      </LayoutRoot>
    </>
  );
};
